var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.startShow)?_c('div',{staticClass:"start-video"},[_c('video',{ref:"video",attrs:{"src":_vm.video,"autoplay":"","muted":""},domProps:{"muted":true}}),_c('div',{staticClass:"esc"},[_vm._v("Esc退出")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }